import { render, staticRenderFns } from "./QueueManagementTable.vue?vue&type=template&id=b669dd72"
import script from "./QueueManagementTable.vue?vue&type=script&lang=js"
export * from "./QueueManagementTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports